import React, { useCallback } from 'react';
import Button from 'react-bootstrap/Button';
import { Download } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import PdfSelectFilterValues from './PdfSelectFilterValues';
import PdfSelectFilterValuesButton from './PdfSelectFilterValuesButton';

import InterestUri from '../../../Enum/InterestUri';

import { useGetPrintButtonEnabled } from '../../../Hook/Interest/UseGetPrintButtonEnabled';
import { useGetFilterValues } from '../../../Hook/Interest/UseGetPdfFilterData';
import { filterValueSelected, pdfRequested } from '../../../Store/Pdf/action';
import { modalRequested } from '../../../Store/Modal/action';
import { shouldCheck } from '../../../Helpers/Interest/PdfHelper';

type Props = RouteComponentProps<{ section: string }>;

const ExportButton: React.FC<Props> = props => {
    const dispatch = useDispatch();
    const { section } = props.match.params;

    const buttonEnabled = useGetPrintButtonEnabled();
    const filterValues = useGetFilterValues();

    const exportPdf = useCallback(() => {
        if (!shouldCheck(section as InterestUri) || filterValues.length < 4) {
            filterValues.forEach(value => dispatch(filterValueSelected(value)));
            dispatch(pdfRequested());
            return;
        }

        dispatch(modalRequested(
            <PdfSelectFilterValuesButton />,
            <PdfSelectFilterValues filterValues={filterValues} section={section as InterestUri} />,
            'Selectie',
            'modal-dialog-wide',
        ));
    }, [filterValues, section]);

    return (
        <Button
            variant="primary"
            className="ml-3 px-3 export-pdf-button"
            onClick={exportPdf}
            title="Download printbaar document"
            disabled={!buttonEnabled}
        >
            <Download size={16} className="mr-2" />
            DOWNLOAD
        </Button>
    );
};

const PdfExportButton = withRouter(ExportButton);

export default PdfExportButton;
